import { keyframes, BeerCls } from '../../../core/ds/index.js'

const ANIMATION_DURATION = 240

const animationEasing = {
  deceleration: 'cubic-bezier(0.0, 0.0, 0.2, 1)',
  acceleration: 'cubic-bezier(0.4, 0.0, 1, 1)',
  spring: 'cubic-bezier(0.175, 0.885, 0.320, 1.175)',
}

const openAnimation = keyframes('openAnimation', {
  from: {
    opacity: 0,
    transform: 'translateY(-120%)',
  },
  to: {
    transform: 'translateY(0)',
  },
})

const closeAnimation = keyframes('closeAnimation', {
  from: {
    transform: 'scale(1)',
    opacity: 1,
  },
  to: {
    transform: 'scale(0.9)',
    opacity: 0,
  },
})

export const animationCls = BeerCls({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  height: 0,
  transition: `all ${ANIMATION_DURATION}ms ${animationEasing.deceleration}`,
  '&.v-enter-active': {
    animation: `${openAnimation} ${ANIMATION_DURATION}ms ${
      animationEasing.spring
    } both`,
  },
  '&.v-leave-active': {
    animation: `${closeAnimation} 120ms ${animationEasing.acceleration} both`,
  },
})
